import { io, Socket } from "socket.io-client";

export default class WebsocketClient {
  private static instance: WebsocketClient | null = null;
  private socket: Socket | null = null;

  // Le constructeur est privé pour éviter l'instanciation directe
  private constructor(private serverUrl: string) {}

  // Méthode pour obtenir l'instance unique de la classe
  public static getInstance(serverUrl: string): WebsocketClient {
    if (!WebsocketClient.instance) {
      WebsocketClient.instance = new WebsocketClient(serverUrl);
    }
    return WebsocketClient.instance;
  }

  isConnected(): boolean {
    if (!this.socket) return false;
    return this.socket?.connected;
  }

  // Initialise la connexion websocket
  connect(callback?: () => void): void {
    const props = {
      transports: ["websocket"],
      query: { clientType: "WEBAPP" },
    };

    // ✅ Si socket déjà créée, ne recrée pas une autre instance
    if (this.socket) {
      // si déjà connectée, callback direct
      if (this.socket.connected) {
        callback?.();
        return;
      }
      // sinon on laisse socket.io gérer la reconnexion
      // et on attache le callback via once
      this.socket.once("connect", () => callback?.());
      this.socket.connect();
      return;
    }

    this.socket = io(this.serverUrl, props);

    this.socket.on("connect", () => callback?.());
    this.socket.on("connect_error", (error: unknown) => {
      console.error("Erreur de connexion WebSocket:", error);
    });
    this.socket.on("error", (error: unknown) => {
      console.error("Error:", error);
    });

    this.socket.connect();
  }

  // Émet un événement avec des données au serveur
  emit(event: string, data?: unknown): void {
    if (this.socket) {
      this.socket.emit(event, data);
    } else {
      console.error("Socket non initialisé. Appelez d'abord connect().");
    }
  }

  // Permet d'écouter un événement du serveur
  on(event: string, callback: (...args: unknown[]) => void): void {
    if (this.socket) {
      this.socket.on(event, callback);
    } else {
      console.error("Socket non initialisé. Appelez d'abord connect().");
    }
  }

  // Retire un écouteur d'un événement
  off(event: string, callback?: (...args: unknown[]) => void): void {
    if (this.socket) {
      if (callback) {
        this.socket.off(event, callback);
      } else {
        this.socket.off(event);
      }
    } else {
      console.error("Socket non initialisé. Appelez d'abord connect().");
    }
  }

  // Ferme la connexion websocket
  disconnect(): void {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }
}
